import { create } from "zustand";

interface JobsFilterState {
  stateId: number | null;
  cityId: number | null;
  districtId: number | null;
  jobType: number | null;
  experience: number | null;
  selectedStatus: number | null;
  categoryId: number | null;
  subCategoryId: number | null;
  startDate: string;
  endDate: string;
  ageFrom: number | null;
  ageTo: number | null;
  gender: string;
  // Where the job was created - derived from user_id server-side, not a
  // stored column (see admin-jobs-service's jobs_service.js).
  source: "admin" | "app" | "";
  applyFilter: boolean;
  searchValue: string;
  paginationModel: { page: number; pageSize: number };

  // setters
  setStateId: (val: number | null) => void;
  setCityId: (val: number | null) => void;
  setDistrictId: (val: number | null) => void;
  setJobType: (val: number | null) => void;
  setExperience: (val: number | null) => void;
  setSelectedStatus: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setSubCategoryId: (val: number | null) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setAgeFrom: (val: number | null) => void;
  setAgeTo: (val: number | null) => void;
  setGender: (val: string) => void;
  setSource: (val: "admin" | "app" | "") => void;
  setApplyFilter: (val: boolean) => void;
  setSearchValue: (val: string) => void;
  setPaginationModel: (val: { page: number; pageSize: number }) => void;
  
  // reset all
  resetFilters: () => void;
}

export const useJobsFilterStore = create<JobsFilterState>((set) => ({
  stateId: null,
  cityId: null,
  districtId: null,
  jobType: null,
  experience: null,
  selectedStatus: null,
  categoryId: null,
  subCategoryId: null,
  startDate: "",
  endDate: "",
  ageFrom: null,
  ageTo: null,
  gender: "",
  source: "",
  applyFilter: true,
  searchValue: "",
  paginationModel: { page: 1, pageSize: 10 },

  setStateId: (val) => set({ stateId: val }),
  setCityId: (val) => set({ cityId: val }),
  setDistrictId: (val) => set({ districtId: val }),
  setJobType: (val) => set({ jobType: val }),
  setExperience: (val) => set({ experience: val }),
  setSelectedStatus: (val) => set({ selectedStatus: val }),
  setCategoryId: (val) => set({ categoryId: val }),
  setSubCategoryId: (val) => set({ subCategoryId: val }),
  setStartDate: (val) => set({ startDate: val }),
  setEndDate: (val) => set({ endDate: val }),
  setAgeFrom: (val) => set({ ageFrom: val }),
  setAgeTo: (val) => set({ ageTo: val }),
  setGender: (val) => set({ gender: val }),
  setSource: (val) => set({ source: val }),
  setApplyFilter: (val) => set({ applyFilter: val }),
  setSearchValue: (val) => set({ searchValue: val }),
  setPaginationModel: (val) => set({ paginationModel: val }),

  resetFilters: () =>
    set({
      stateId: null,
      cityId: null,
      districtId: null,
      jobType: null,
      experience: null,
      selectedStatus: null,
      categoryId: null,
      subCategoryId: null,
      startDate: "",
      endDate: "",
      ageFrom: null,
      ageTo: null,
      gender: "",
      source: "",
      applyFilter: true,
      searchValue: "",
      paginationModel: { page: 1, pageSize: 10 },
    }),
}));
